import './App.css';
import { Route, Routes } from "react-router-dom";
import Header from "./Components/Header";
import Home from "./Components/Home";
import Aboutus from "./Components/Aboutus";
import Services from "./Components/Services.js";
import Converter from "./Components/Converter";
import ResumeHome from "./Resume Components/Pages/ResumeHome.js";
import ContactUs from './Resume Components/ContactUs';
import Protect from './Resume Components/Pages/Login and Sign UP/Protect.js';
import AboutUs from './Resume Components/AboutUs';
import ChooseDesForLoggedInUser from "./Resume Components/Pages/Designes  FOLDER/Designsecond components/ChooseDesForLoggedInUser";
import SeeDesigns from "./Resume Components/Pages/Designes  FOLDER/Designsecond components/SeeDesigns";
import AllComponentsContainer from "./Resume Components/Components/FillingForrmComponents/AllComponentsContainer.js";
import ChooseYourDesign from "./Resume Components/Pages/Designes  FOLDER/Designsecond components/ChooseYourDesign.js";
import DesignFourth from "./Resume Components/Pages/Designes  FOLDER/DesignFourth.js";
import DesignThird from "./Resume Components/Pages/Designes  FOLDER/DesignThird.js";
import DesignFirst from "./Resume Components/Pages/Designes  FOLDER/DesignFirst.js";
import DesignSecond from "./Resume Components/Pages/Designes  FOLDER/DesignSecond.js";
import Pdgtojpeg from "./Components/Converter component/Pdgtojpeg.js";
import AadhaarManual from "./Components/Print Manual Card Component/AadhaarManual.js";
import PanManual from "./Components/Print Manual Card Component/PanManual.js";
import AadhaarPrintComp from "./Components/Print Manual Card Component/AadhaarPrintComp.js";
import { useState } from 'react';
import PanPrintComp from './Components/Print Manual Card Component/PanPrintComp.js';
import JpegToPdf from './Components/Converter component/JpegToPdf.js';
import ImageResize from './Components/Converter component/ImageResize.js';
import LoginPage from './Resume Components/Pages/Login and Sign UP/LoginPage.js';
import UserLogInPage from './Resume Components/LogInComponents/UserLogInPage.js';
import SignUpPage from './Resume Components/Pages/Login and Sign UP/SignUpPage.js';
import ForgotPassword from './Resume Components/LogInComponents/ForgotPassword.js';
import Registrationdetails from './Resume Components/Pages/Registrationdetails.js';
import Appjob from './jobsite/Appjob.js';
import ShowpostallDetails from './jobsite/Components/ShowpostallDetails.js';
import LatestJobs from './jobsite/Components/LatestJobs.js';
import Admitcard from './jobsite/Components/Admitcard.js';
import Results from './jobsite/Components/Results.js';
import Admitcardfloatcomponent from './jobsite/Components/Admitcardfloatcomponent.js';
import ResultDownloadFloatingComp from './jobsite/Components/ResultDownloadFloatingComp.js';
import DevloperPage from './Components/DevloperPage.js';
import DevloperLoginPage from './Components/DevloperLoginPage.js';
import Formfillercomp from './Components/Formfillercomp.js';
import Applicantsregdet from './Components/Applicantsregdet.js';
import Formfillingcont from './Components/Formfillingcont.js';
import Cybercafe from './Components/Cybercafe.js';
import Pdftoword from './Components/Converter component/Pdftoword.js' 
import Pdftoexcel from './Components/Converter component/Pdftoexcel.js' 
import Pdftopowerpoint from './Components/Converter component/Pdftopowerpoint.js';
import ShareImages from './Components/ShareImages.js';   
let App= ()=>{
  let [senddata, setsenddata]=useState('');
  let funfun=(recdata)=>{
    setsenddata(recdata)

  }
  let [sendpandata, setsendpandata]=useState('');
  let funfunpan=(recdata)=>{
    setsendpandata(recdata)

  }
  let [applicantdata, setapplicantdata] = useState(null);
  let getdataformsearchcomp=(recdata)=>{
      setapplicantdata(recdata);
  }
  let errorshowfun=(sucesmsg, errormsg)=>{
    const succ = document.querySelector(".success")
    const errorr = document.querySelector(".error")
    succ.innerHTML=sucesmsg;
    errorr.innerHTML=errormsg;
    if(errorr.innerHTML !== "" || succ.innerHTML !== ""){
        errorr.style.cssText = "right: -20px; color: white; background-color: red; transition: all 0.7s ease; border-radius: 5px;"
        setTimeout(() => {
            errorr.style.cssText = "right: -400px; color: white; background-color: red; transition: all 3s ease; border-radius: 5px; font-size: 10px;";
        }, 2000);


        succ.style.cssText = "right: -20px; color: white; background-color: green; transition: all 0.7s ease; display: block; z-index: 1000; border-radius: 5px;"
        setTimeout(() => {
            succ.style.cssText = "right: -400px; color: white; background-color: green; transition: all 3s ease; display: block; z-index: 1000; border-radius: 5px; font-size: 10px;";
        }, 3000);
    }
    if(errorr.innerHTML !== ""){
        succ.style.cssText="display: none; transition: all 2s ease;"
    }
    
    
    
    
}
  return(
    <div className='appmaincont'>
      <Header/>  
      <div className='popupdiv'>
          <p style={{backgroundColor:"green", color:"white"}} className='success samemsg'>ghgh</p>
          <p style={{backgroundColor:"red", color:"white"}} className='error samemsg'>gg</p>
      </div> 
      <Routes>
        <Route path="/" element={<Home/>}/> 
        <Route path="pdftojpegconvert" element={<Pdgtojpeg/>}/>
        <Route path='jpegtopdf' element={<JpegToPdf/>}/>
        <Route path='ImageResizer' element={<ImageResize/>}/>
        <Route path="Aboutus" element={<Aboutus/>}/>
        <Route path='DevloperPanel' element={<DevloperPage Successandrerrorfun={errorshowfun}/>}/>
        <Route path='Devloper-log-in-page' element={<DevloperLoginPage Successandrerrorfun={errorshowfun}/>}/>
        <Route path='Share-Images' element={<ShareImages/>}/>
        <Route path="printManual" element={<AadhaarPrintComp inputs={senddata} />}/>
        <Route path="panprintManual" element={<PanPrintComp paninputs={sendpandata} />}/>
        <Route path="Services" element={<Services/>}/>
        <Route path="/MakeResume/*" element={<ResumeHome Successandrerrorfun={errorshowfun}/>}>
          <Route path='LoginPage' element={<LoginPage/>}/>
          <Route path='SignUpPage' element={<SignUpPage/>}/>
          <Route path='forgotpassword' element={<ForgotPassword/>}/>
          <Route path='AllDes' element={<SeeDesigns/>}/> 
          <Route path='contactus' element={<ContactUs/>}/>
          <Route path='AboutUs' element={<AboutUs/>}/>
          <Route path='ChooseYourQualification' element={<AllComponentsContainer/>}/>
          <Route path='ChooseYourDesign' element={<ChooseYourDesign/>}/>
          <Route path='DesignFourth' element ={<DesignFourth/>}/>             
          <Route path='DesignThird' element={<DesignThird />}/>
          <Route path='DesignSecond' element={<DesignSecond />}/>
          <Route path='DesignFirst' element={<DesignFirst />}/>
          <Route path="UserLoginPage" element={<Protect Component={UserLogInPage}/>}>
            <Route path='Registration' element={<Registrationdetails/>}/>
            <Route path='ChooseDes' element={<ChooseDesForLoggedInUser/>}/>
            <Route path='DesignThird' element={<DesignThird/>}/>
            <Route path='DesignFourth' element ={<DesignFourth/>}/>
            <Route path='DesignSecond' element={<DesignSecond/>}/>
            <Route path='DesignFirst' element={<DesignFirst/>}/>
          </Route>   
      </Route>
      <Route path="Converter/*" element={<Converter/>}>
        <Route path="pdftojpegconvert" element={<Pdgtojpeg/>}/>
        <Route path='pdftoword' element={<Pdftoword/>}/>
        <Route path='jpegtopdf' element={<JpegToPdf/>}/>
        <Route path='pdftoexcel' element={<Pdftoexcel/>}/>
        <Route path='pfgtopowerpoint' element={<Pdftopowerpoint/>}/>
      <Route path='ImageResizer' element={<ImageResize/>}/>
      </Route>  
      <Route path="aadhaarcard-manual" element={<AadhaarManual Successandrerrorfun={errorshowfun} Gotdata={funfun}/>}/>
      <Route path="pan-manual" element={<PanManual Successandrerrorfun={errorshowfun} gotpandata={funfunpan}/>}/>    

      <Route path='search-jobs.com' element={<Appjob/>}>
          <Route path='VacancyDetails' element={<ShowpostallDetails/>}/>
          <Route path='LatestJobs' element={<LatestJobs/>}/>
          <Route path='Admitcard' element={<Admitcard/>}/>
          <Route path='Results' element={<Results/>}/> 
          <Route path='AdmitcardDownload' element={<Admitcardfloatcomponent/>}/>
          <Route path='ResultDownload' element={<ResultDownloadFloatingComp/>}/>
        </Route>
        <Route path='forms-filler-comp' element={<Formfillercomp Successandrerrorfun={errorshowfun} getapplicantdata={getdataformsearchcomp}/>}/>
        <Route path='applicants-register-form' element={<Applicantsregdet Successandrerrorfun={errorshowfun}/>}/> 
        <Route path='applicant-form-filling' element={<Formfillingcont  applicantdata={applicantdata} Successandrerrorfun={errorshowfun}/>}/>  
        <Route path='cyber-cafe-point' element={<Cybercafe/>}/> 
     </Routes>
      
     
    </div>
  );

} 
 

export default App;